import React from 'react'

import { Box, Display, FlexDirection, GridDisplay } from '@gousto-internal/citrus-react'
import type { RecipeGridContentBlock } from '@library/api-menu-experience'

import { RecipeCount } from '../CollectionScreen/RecipeCount'

type RecipeGridProps = {
  contentBlock: RecipeGridContentBlock
  recipeCountTextColor?: string
}

const PLACEHOLDER_COLOR = '#000000'

export const recipeGridTemplateColumns: [string, null, string, string] = [
  'minmax(0, 1fr)',
  null,
  'repeat(2, minmax(0, 1fr))',
  'repeat(3, minmax(0, 1fr))',
]

export const recipeGridGap: [3, null, 4] = [3, null, 4]

export const RecipeGrid = ({ contentBlock, recipeCountTextColor }: RecipeGridProps) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    gap={3}
    data-testid="recipe-grid"
  >
    <RecipeCount count={contentBlock.recipeCount} textColor={recipeCountTextColor} />
    <Box
      display={GridDisplay.Grid}
      gridTemplateColumns={recipeGridTemplateColumns}
      gap={recipeGridGap}
      data-testid="recipe-grid-items"
    >
      {contentBlock.items
        .filter((item) => item.type === 'standard-recipe')
        .map((item) => (
          <Box
            key={item.id}
            aria-hidden
            data-testid="recipe-grid-placeholder"
            data-recipe-id={item.id}
            style={{
              aspectRatio: '1 / 1',
              backgroundColor: PLACEHOLDER_COLOR,
            }}
          />
        ))}
    </Box>
  </Box>
)
